import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname,
    });
  }, [location.pathname]);

  return null;
};

export default RouteChangeTracker;
